module.exports = __webpack_public_path__ + "img/layout_top.499b6938.svg";